import Login from "../Components/Auth/Login";
import Account from "../Screens/User/Account";
import ApplicationDownload from "../Screens/User/ApplicationDownload";
import Home from "../Screens/User/Home";
import Orders from "../Screens/User/Orders";
import PrivacyPolicy from "../Screens/User/PrivacyPolicy";
import Products from "../Screens/User/Products";
import AllVarieties from "../Screens/User/AllVarieties";
import AllSpecialVarieties from "../Screens/User/AllSpecialVarieties";
import Quotations from "../Screens/User/Quotations";
import RefundPolicy from "../Screens/User/RefundPolicy";
import RequirementFill from "../Screens/User/RequirementFill";
import TermsAndConditions from "../Screens/User/TermsAndConditions";
import Wallet from "../Screens/User/Wallet";
import PostOrderViaOffer from "../Screens/User/PostOrderViaOffer";
import AllOffers from "../Screens/User/AllOffers";
import Returns from "../Screens/User/Returns";
import Declarations from "../Screens/User/Declarations";
import ContactUs from "../Screens/User/ContactUs";
import Career from "../Screens/User/Career";
import DigilockerCallback from "../Screens/User/DigilockerCallback";
import PartnerGatePasses from "../Screens/User/PartnerGatePasses";

// ─── SUPPLIER SCREENS ──────────────────────────────────
import SupplierOrders from "../Screens/User/SupplierOrders";
import SupplierQuotationList from "../Screens/User/SupplierQuotationList";
import SupplierCreateQuotation from "../Screens/User/SupplierCreateQuotation";
import SupplierQuotationDetails from "../Screens/User/SupplierQuotationDetails";
import SupplierReturnedOrders from "../Screens/User/SupplierReturnedOrders";
import SupplierRQMRequests from "../Screens/User/SupplierRQMRequests";
import PostRQMRequest from "../Screens/User/PostRQMRequest";
import SupplierRQMDetails from "../Screens/User/SupplierRQMDetails";
import SupplierLinkedVarieties from "../Screens/User/SupplierLinkedVarieties";
import SupplierPenalties from "../Screens/User/SupplierPenalties";
import BuyerPenalties from "../Screens/User/BuyerPenalties";

const userRoutes = [
  // ─── GENERAL / PUBLIC ROUTES ──────────────────────────
  {
    path: "/",
    component: <Home />,
    protected: false,
  },
  {
    path: "/application-download",
    component: <ApplicationDownload />,
    protected: false,
  },
  {
    path: "/products",
    component: <Products />,
    protected: false,
  },
  {
    path: "/all-varieties",
    component: <AllVarieties />,
    protected: false,
  },
  {
    path: "/special-varieties",
    component: <AllSpecialVarieties />,
    protected: false,
  },
  {
    path: "/all-special-varieties",
    component: <AllSpecialVarieties />,
    protected: false,
  },
  {
    path: "/all-offers",
    component: <AllOffers />,
    protected: false,
  },
  {
    path: "/terms-and-conditions",
    component: <TermsAndConditions />,
    protected: false,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
    protected: false,
  },
  {
    path: "/refund-policy",
    component: <RefundPolicy />,
    protected: false,
  },
  {
    path: "/contact-us",
    component: <ContactUs />,
    protected: false,
  },
  {
    path: "/career",
    component: <Career />,
    protected: false,
  },

  // ─── BUYER ROUTES ─────────────────────────────────────
  {
    path: "/post-requirement",
    component: <RequirementFill />,
    protected: true,
  },
  {
    path: "/post-order-via-offer",
    component: <PostOrderViaOffer />,
    protected: true,
  },
  {
    path: "/orders",
    component: <Orders />,
    protected: true,
  },
  {
    path: "/quotations",
    component: <Quotations />,
    protected: true,
  },

  // ─── SUPPLIER ROUTES ──────────────────────────────────
  {
    path: "/supplier-orders",
    component: <SupplierOrders />,
    protected: true,
  },
  {
    path: "/supplier-quotations",
    component: <SupplierQuotationList />,
    protected: true,
  },
  {
    path: "/create-quotation",
    component: <SupplierCreateQuotation />,
    protected: true,
  },
  {
    path: "/supplier-quotation-details",
    component: <SupplierQuotationDetails />,
    protected: true,
  },
  {
    path: "/supplier-returned-orders",
    component: <SupplierReturnedOrders />,
    protected: true,
  },
  {
    path: "/supplier-rqm-requests",
    component: <SupplierRQMRequests />,
    protected: true,
  },
  {
    path: "/post-rqm-request",
    component: <PostRQMRequest />,
    protected: true,
  },
  {
    path: "/supplier-rqm-details",
    component: <SupplierRQMDetails />,
    protected: true,
  },
  {
    path: "/supplier-linked-varieties",
    component: <SupplierLinkedVarieties />,
    protected: true,
  },
  {
    path: "/supplier-penalties",
    component: <SupplierPenalties />,
    protected: true,
  },
  {
    path: "/buyer-penalties",
    component: <BuyerPenalties />,
    protected: true,
  },

  // ─── COMMON AUTHENTICATED USER ROUTES ─────────────────
  {
    path: "/returns",
    component: <Returns />,
    protected: true,
  },
  {
    path: "/wallet",
    component: <Wallet />,
    protected: true,
  },
  {
    path: "/account",
    component: <Account />,
    protected: true,
  },
  {
    path: "/declarations",
    component: <Declarations />,
    protected: true,
  },
  {
    path: "/gate-passes",
    component: <PartnerGatePasses />,
    protected: true,
  },
];

const noAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/digilocker-callback",
    component: <DigilockerCallback />,
  },
];

export { userRoutes, noAuthRoutes };
